import React, { createContext, useContext, useState, useCallback } from 'react';
import FilterDrower from '../layouts/FilterDrower';
const FilterDrowerContext = createContext();
export const useFilterDrower = () => {
  return useContext(FilterDrowerContext);
};

export const FilterDrowerProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [drawerContent, setDrawerContent] = useState(null);
  const [drawerProps, setDrawerProps] = useState({});
  const [drawerTitle, setDrawerTitle] = useState("Filter");
  const [onClearCallback, setOnClearCallback] = useState(null);
  const [onSubmitCallback, setOnSubmitCallback] = useState(null);

  const openFilterDrower = (content, { title = "Filter", onClear, onSubmit, ...rest } = {}) => {
    setDrawerContent(content);
    setDrawerTitle(title);
    setDrawerProps(rest);
    // Store callbacks wrapped in functions to prevent React from invoking them
    setOnClearCallback(() => onClear || null);
    setOnSubmitCallback(() => onSubmit || null);
    setShow(true);
  };

  const closeFilterDrower = useCallback(() => {
    setShow(false);
    setTimeout(() => {
      setDrawerContent(null);
      setDrawerProps({});
      setDrawerTitle("Filter");
      setOnClearCallback(null);
      setOnSubmitCallback(null);
    }, 300);
  }, []);

  return (
    <FilterDrowerContext.Provider value={{ openFilterDrower, closeFilterDrower }}>
      {children}
      <FilterDrower
        show={show}
        handleClose={closeFilterDrower}
        title={drawerTitle}
        onClear={onClearCallback}
        onSubmit={onSubmitCallback}
        props={drawerProps}
      >
        {drawerContent}
      </FilterDrower>
    </FilterDrowerContext.Provider>
  );
};
